/**
 * @generated SignedSource<<f33b67b5718c9525429204d384c2c72f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment$data = {
  readonly count: number;
  readonly id: string;
  readonly " $fragmentType": "RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment";
};
export type RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment$key = {
  readonly " $data"?: RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "type": "RandomMultipleChoiceElement",
  "abstractKey": null
};

(node as any).hash = "c2ca96b0c256d95e58190c6238db7dad";

export default node;
